export const ROUTES = {
    HOME: '/',
    CLIENT_CREDENTIALS: '/client-credentials',
    SIGNIN: '/signin',
} as const;

export type RouteKeys = keyof typeof ROUTES;
export type RoutePaths = typeof ROUTES[RouteKeys];

// Helper function to build route with language suffix
export const buildRouteWithLang = (route: RoutePaths | string, lang?: string): string => {
    if (!lang || lang === 'en') {
        return route || '/';
    }
    if (route === '/') {
        return `/${lang}`;
    }
    return `${route}/${lang}`;
};

// Extract the base path (without language suffix) from a full path
export const getBasePathFromUrl = (pathname: string): string => {
    const match = pathname.match(/^(.*?)\/(en|fr)$/);
    if (match) {
        return match[1] || '/';
    }
    return pathname;
};

// Extract language from URL path (suffix)
export const getLangFromUrl = (pathname: string): string | null => {
    const match = pathname.match(/\/(en|fr)$/);
    return match ? match[1] : null;
};